type ProjectAnswer = { label: string; value: string }

const ANNUAL_COMPANY_REVENUE_RANGE: Array<ProjectAnswer> = [
  { label: 'Over $50,000,000', value: 'OVER_$50,000,000' },
  { label: '$20,000,001 to $50,000,000', value: '$20,000,001_TO_$50,000,000' },
  { label: '$10,000,001 to $20,000,000', value: '$10,000,001_TO_$20,000,000' },
  { label: '$5,000,001 to $10,000,000', value: '$5,000,001_TO_$10,000,000' },
  { label: '$1,000,001 to $5,000,000', value: '$1,000,001_TO_$5,000,000' },
  { label: '$500,000 to $1,000,000', value: '$500,000_TO_$1,000,000' },
  { label: 'Under $500,000', value: 'UNDER_$500,000' },
  { label: 'Pre-revenue', value: 'PRE_REVENUE' },
  { label: 'Unknown', value: 'UNKNOWN' },
]

const COMPANY_REVENUE_MODEL: Array<ProjectAnswer> = [
  { label: 'Financial Services', value: 'FINANCIAL_SERVICES' },
  { label: 'Wholesale', value: 'WHOLESALE' },
  { label: 'Subscription', value: 'SUBSCRIPTION' },
  { label: 'Saas', value: 'SAAS' },
  { label: 'Retail', value: 'RETAIL' },
  { label: 'Rental or Leasing', value: 'RENTAL_OR_LEASING' },
  { label: 'Professional Services', value: 'PROFESSIONAL_SERVICES' },
  { label: 'Manufacturing', value: 'MANUFACTURING' },
  { label: 'E-Commerce', value: 'E_COMMERCE' },
  { label: 'Construction', value: 'CONSTRUCTION' },
  { label: 'Non-profits / Government funded', value: 'NON_PROFITS_GOVERNMENT_FUNDED' },
  { label: 'Marketplaces', value: 'MARKETPLACES' },
  { label: 'Utilities / Natural resources', value: 'UTILITIES_NATURAL_RESOURCES' },
  { label: 'Unknown', value: 'UNKNOWN' },
]

const COMPANY_SIZE: Array<ProjectAnswer> = [
  { label: '1000+ Employees', value: '1000+_EMPLOYEES' },
  { label: '500 to 1000 Employees', value: '500_TO_1000_EMPLOYEES' },
  { label: '251 to 500 Employees', value: '251_TO_500_EMPLOYEES' },
  { label: '101 to 250 Employees', value: '101_TO_250_EMPLOYEES' },
  { label: '50 to 100 Employees', value: '50_TO_100_EMPLOYEES' },
  { label: '11 to 50 Employees', value: '11_TO_50_EMPLOYEES' },
  { label: '6 to 10 Employees', value: '6_TO_10_EMPLOYEES' },
  { label: '1 to 5 Employees', value: '1_TO_5_EMPLOYEES' },
  { label: 'Self-Employed', value: 'SELF_EMPLOYED' },
  { label: 'Unknown', value: 'UNKNOWN' },
]

const COMPANY_TYPE: Array<ProjectAnswer> = [
  { label: 'Sole Proprietorship', value: 'SOLE_PROPRIETORSHIP' },
  { label: 'Partnership', value: 'PARTNERSHIP' },
  { label: 'C-Corp', value: 'C_CORP' },
  { label: 'S-Corp', value: 'S_CORP' },
  { label: 'Non-Profit', value: 'NON_PROFIT' },
  { label: 'Trust', value: 'TRUST' },
  { label: 'Government', value: 'GOVERNMENT' },
  { label: 'Unknown', value: 'UNKNOWN' },
]

const FUNDING_SOURCE = [
  { label: 'Venture Capital', value: 'VENTURE_CAPITAL' },
  { label: 'Personal Investing', value: 'PERSONAL_INVESTING' },
  { label: 'Peer-to-Peer Lending', value: 'PEER_TO_PEER_LENDING' },
  { label: 'Partnerships', value: 'PARTNERSHIPS' },
  { label: 'Major Customer(s)', value: 'MAJOR_CUSTOMERS' },
  { label: 'Government Grants and Subsidies', value: 'GOVERNMENT_GRANTS_AND_SUBSIDIES' },
  { label: 'Friends and Family', value: 'FRIENDS_AND_FAMILY' },
  { label: 'Crowdfunding', value: 'CROWDFUNDING' },
  { label: 'Business Incubator or Accelerators', value: 'BUSINESS_INCUBATOR_OR_ACCELERATORS' },
  { label: 'Bartering', value: 'BARTERING' },
  { label: 'Bank Loans or Lines of Credit', value: 'BANK_LOANS_OR_LINES_OF_CREDIT' },
  { label: 'Angel Investors', value: 'ANGEL_INVESTORS' },
  { label: 'Unknown', value: 'UNKNOWN' },
]

const PROJECT_SIZE_ITEMS = [
  {
    label: 'Large Recurring (35+ hrs monthly)',
    value: 'LARGE_RECURRING',
  },
  {
    label: 'Med Recurring (10-35hrs monthly)',
    value: 'MED_RECURRING',
  },
  {
    label: 'Small Recurring (<10hrs monthly)',
    value: 'SMALL_RECURRING',
  },
  { label: 'Large One-time (40+ hrs)', value: 'LARGE_ONE_TIME' },
  { label: 'Med One-time (10-40hrs)', value: 'MED_ONE_TIME' },
  { label: 'Small One-time (<10hrs)', value: 'SMALL_ONE_TIME' },
]

const PROJECT_SIZE = [
  {
    id: 'LARGE_RECURRING',
    value: { hoursMonthly: 'OVER_35_HOURS', hoursTotal: null, isRecurring: true },
  },
  {
    id: 'MED_RECURRING',
    value: { hoursMonthly: '10_TO_35_HOURS', hoursTotal: null, isRecurring: true },
  },
  {
    id: 'SMALL_RECURRING',
    value: { hoursMonthly: 'UNDER_10_HOURS', hoursTotal: null, isRecurring: true },
  },
  { id: 'LARGE_ONE_TIME', value: { hoursMonthly: null, hoursTotal: 'OVER_40_HOURS', isRecurring: false } },
  { id: 'MED_ONE_TIME', value: { hoursMonthly: null, hoursTotal: '10_TO_40_HOURS', isRecurring: false } },
  { id: 'SMALL_ONE_TIME', value: { hoursMonthly: null, hoursTotal: 'UNDER_10_HOURS', isRecurring: false } },
]

const INTERNATIONAL_OPTIONS = [
  { label: 'Yes', value: 'true', color: 'primary' },
  { label: 'No', value: 'false', color: 'primary' },
]

const ONSITE_OPTIONS = [
  { label: 'Yes, locally', value: 'LOCAL', color: 'primary' },
  { label: 'Yes, traveled', value: 'TRAVELED', color: 'primary' },
  { label: 'No, remote', value: 'REMOTE', color: 'primary' },
]

export {
  ANNUAL_COMPANY_REVENUE_RANGE,
  COMPANY_REVENUE_MODEL,
  COMPANY_SIZE,
  COMPANY_TYPE,
  FUNDING_SOURCE,
  INTERNATIONAL_OPTIONS,
  PROJECT_SIZE,
  PROJECT_SIZE_ITEMS,
  ONSITE_OPTIONS
}
